@if (news) {
  <h2 class="title">{{ news.title }}</h2>
  <div class="news-time-ago">Utworzono: {{ news.created | date: 'yyyy-MM-dd HH:mm' }} </div>
}

@if (news) {
  <div class="news-detail-card">
    <div class="news-detail-top">
      <div class="news-detail-left">
        @if (news.file) {
          <div class="news-image-box">
            <img [src]="imagesUrl + news.file" [alt]="news.title" />
          </div>
        }
      
      </div>
      <div class="news-detail-right">
        
        <div class="news-detail-content">
          <div #contentContainer [innerHTML]="news.content"></div>
        </div>
      </div>
    </div>
  </div>
}